__turbopack_context__.v({
  "accountAge": "index-module-scss-module__XVje9a__accountAge",
});
